<template>
  <div>
    <v-data-iterator
      :items="shownOnDashboard ? upcomingSurveyList : surveyList"
      :page.sync="page"
      :search="search"
      :custom-filter="customFilter"
      :items-per-page="itemsPerPage"
      :footer-props="{
        'items-per-page-text': $t('lblRowsPerPage'),
      }"
      :no-results-text="$t('emptySearchRecords')"
    >
      <template slot="no-data">
        <strong>{{ $t("noData") }}</strong>
      </template>
      <template v-slot:default="props">
        <v-row>
          <v-col
            v-for="item in props.items"
            :key="item.id"
            cols="12"
            sm="12"
            :md="shownOnDashboard ? 12 : 6"
            :lg="shownOnDashboard ? 12 : 4"
            style="padding: 10px"
          >
            <survey-card
              :item="item"
              :shownOnDashboard="shownOnDashboard"
            ></survey-card>
          </v-col>
        </v-row>
      </template>
    </v-data-iterator>
  </div>
</template>

<script>
import SurveyCard from "./SurveyCard.vue";
import SignalRMixin from "../../mixin/SignalRMixin";
export default {
  components: { SurveyCard },
  mixins: [SignalRMixin],
  name: "SurveyGrid",
  props: {
    items: {
      type: Array,
      default: () => [],
    },

    search: String,
    itemsPerPage: {
      type: Number,
      default: -1,
    },
    shownOnDashboard: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      page: 1,
    };
  },
  computed: {
    selectedLang() {
      return this.$i18n.locale;
    },
    surveyList() {
      return this.items
        .map(({ _self, ...obj }) => ({
          ...obj,
          surveyStatus: this.getSurveyStatus(obj),
          commencementDate: this.getDateInternationalDate(obj.startDate),
          expiryDate: this.getDateInternationalDate(obj.endDate),
        }))
        .sort(function (a, b) {
          return new Date(b.startDate) - new Date(a.startDate);
        });
    },
    upcomingSurveyList() {
      return this.surveyList.filter(
        (f) =>
          f.surveyStatus.value === "upcoming" ||
          f.surveyStatus.value === "active"
      );
      //return this.items;
    },
  },
  methods: {
    customFilter(items, search) {
      return items.filter((row) => {
        if (!search) {
          return true;
        } else {
          search = search.toString().toLowerCase();
          return (
            row.title.toLowerCase().includes(search) ||
            row.type.toLowerCase().includes(search) ||
            row.surveyStatus.value.toLowerCase().includes(search) ||
            row.userid.toLowerCase().includes(search)
          );
        }
      });
    },
    getDateInternationalDate(dateString) {
      var Xmas95 = new Date(dateString);
      var options = { dateStyle: "full", timeStyle: "short" };
      return new Intl.DateTimeFormat(this.selectedLang, options).format(Xmas95);
    },
    getSurveyStatus(survey) {
      let startDate = new Date(survey.startDate);
      let endDate = new Date(survey.endDate);
      let today = new Date();

      if (startDate > today) {
        return {
          text: this.$t("poll.Upcoming"),
          value: "upcoming",
          color: "primaryDark2 darken-1",
        };
      }
      if (endDate < today) {
        return {
          text: this.$t("poll.Expired"),
          value: "expired",
          color: "Neutral darken-3",
        };
      }
      if (startDate <= today) {
        return {
          text: this.$t("poll.Active"),
          value: "active",
          color: "primary lighten-2",
        };
      }
    },
  },
};
</script>

<style>
</style>